<template>
    <AuthenticatedLayout>
        <h2>Deals</h2>
        <div class="w-full" id="chart_container">
            <trading-vue
                ref="chart"
                id="chart_container"
                type="candles"
                :width="2000"
                color-back="#ffffff"
                color-grid="#eee"
                color-text="#333"
                :timezone="3"
                titleTxt="MA"
                :data="data_chart"
            ></trading-vue>
        </div>
    </AuthenticatedLayout>
</template>

<script>
export default {
    metaInfo() {
        return {
            "title": "Chart"
        }
    },
    components: {

    },
    props: {
        replayResult: Object,
        replayId: Number,

        botName: String|undefined,
        botResultData: Object|undefined,
        candles: Array|undefined
    },
    data() {
        return {

        }
    },
    methods: {
        ...helperMethods,
        selectBot(bot) {
            //this.botResultData = bot;
            this.$inertia.visit(`/replay/${this.replayId}/${bot.name}`)
        },
    }
}
</script>
